<!--
  @description 业务拨测
  @author xiehan
  @date 2018/12/03
-->
<template>
  <div class="dial__content">
    <el-form ref="searchForm" :model="searchForm" :inline="true" input-width="auto">
      <el-form-item>
        <el-input v-model="searchForm.name" :placeholder="$t('dial.name')"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" 
          @click="e_search" 
          v-g-rac="gRac('dial_search')" 
          v-text="$t('common.search')"></el-button>
        <el-button type="primary" 
          @click="jump2Task"
          v-g-rac="gRac('dial_addTask')" 
          v-text="$t('dial.addTask')"></el-button>
        <el-button type="primary" 
          @click="jump2Terminal"
          v-g-rac="gRac('dial_addTerminalTask')" 
          v-text="$t('dial.addTerminalTask')"></el-button>
        <el-button type="primary" 
          @click="deleteAll"
          v-g-rac="gRac('dial_deleteAll')"
          v-text="$t('common.delete')"></el-button>
      </el-form-item>
    </el-form>
    <el-table-extend
      :data="tData" 
      :head="tHead" 
      :selection="true"
      :selectionChange="tableSelect"
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import table from '@/components/mixins/table'
  import dialBiz from '@/logic/intelligentMonitor/dialBiz'
  import TimeFormat from '@/utils/timeFormat'
  import { extend } from '@/utils/tool'
  export default {
    mixins: [rac, table],
    data () {
      return {
        tableSelectList: [],
        searchForm: {
          name: ''
        },
        tableControl: [
          {
            labelFun: (data) => {
              return data.status === this.$t('dial.running') ? this.$t('dial.stop') : this.$t('dial.run')
            },
            callback: (row, index, data) => {
              if (row.status === this.$t('dial.running')) {
                dialBiz.stop({ id: row.id }).then(() => {
                  this.handleSuccess()
                })
              } else {
                dialBiz.start({ id: row.id }).then(() => {
                  this.handleSuccess()
                })
              }
            },
            rac: () => this.gRac('dial_Status')
          }, {
            label: this.$t('common.check'),
            callback: this.checkDial,
            rac: () => this.gRac('dial_detail')
          }, {
            label: this.$t('common.edit'),
            callback: (row, index, data) => {
              this.$router.push({ name: row.type === 'TCPEP' ? 'handlerDialTermianl' : 'handlerDial',
                query: { id: row.id } })
            },
            rac: () => this.gRac('dial_amend')
          }, {
            label: this.$t('common.delete'),
            callback: (row, index, data) => {
              this.deleteTask([row.id])
            },
            rac: () => this.gRac('dial_delete')
          }
        ]
      }
    },
    methods: {
      initTable () {
        this.tInitTable({
          lanKey: 'dial.table',
          head: ['name', 'desc', 'status', 'resAvailability', 'delay', 'type', 'currentTime'],
          requestFun: this.search,
          headOpt: {}
        })
      },
      e_search () {
        this.tResetPage()
        this.search()
      },
      search () {
        const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
        dialBiz.findAll(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map(item => {
              item.currentTime = TimeFormat.getFormatTime(item.currentTime)
              item.resAvailability += '%'
              item.delay += 'ms'
              item.status = item.status ? this.$t('dial.running') : this.$t('dial.stopping')
            })
          }
          this.tData = data
        })
      },
      deleteAll () {
        if (this.tableSelectList.length === 0) {
          this.$message({
            message: this.$t('common.selectTips'),
            type: 'warning'
          })
          return
        }
        let idList = this.tableSelectList.map(item => item.id)
        this.deleteTask(idList)
      },
      deleteTask (ids) {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          dialBiz.deleteTask({ ids: ids }).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.search()
          })
        }).catch(() => {})
      },
      handleSuccess () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
        this.search()
      },
      tableSelect (val) {
        this.tableSelectList = val
      },
      checkDial (val) {
        this.$router.push({ name: 'dialDetail', query: { id: val.id, name: val.name } })
      },
      jump2Task () {
        this.$router.push({ name: 'handlerDial' })
      },
      jump2Terminal () {
        this.$router.push({ name: 'handlerDialTermianl' })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'dial' && (from.name === 'handlerDialTermianl' || from.name === 'handlerDial')) {
          this.search()
        }
      }
    },
    mounted () {
      this.initTable()
      this.search()
    }
  }
</script>

<style scoped>

</style>